import {get} from 'lodash';
import de from '../../lang/de.json';
import en from '../../lang/en.json';

const Helpers = {

    install(Vue) {

        Vue.mixin({
            methods: {
                __(text, replace = {}) {
                    let line = text;
                    switch (window.language) {
                        case 'bg':
                        case 'BG':
                            line = bg[text] ? bg[text] : text;
                            break;
                        case 'de':
                        case 'DE':
                            line = de[text] ? de[text] : text;
                            break;
                        case 'en':
                        case 'EN':
                            line = en[text] ? en[text] : text;
                            break;
                    }

                    if (_.isEmpty(replace)) {
                        return line;
                    }

                    Object.entries(replace).forEach((variable) => {
                        line = line.replace(':' + variable[0], variable[1])
                    });
                    return line;

                },
                cms(key) {
                    let placeholder = [];

                    if (window.cms) {
                        placeholder = window.cms;
                    }

                    if (placeholder[key]) {
                        return placeholder[key];
                    }
                    return {
                        title: '',
                        body: '',
                    };
                },
                parsePlaceholder(key) {
                    let placeholder = [];

                    if (window.cms) {
                        placeholder = window.cms;
                    }

                    if (placeholder[key]) {
                        return placeholder[key].title.split('%');
                    }
                    return {
                        title: '',
                        body: '',
                    };


                },
                url(...parts) {
                    return parts.unshift(window.basePath), parts.map(el => el.toString().replace(/\/$/, '')).join('/');
                },
                handleError(err) {
                    window.events.$emit('notify', {class: 'danger', message: err.message});
                },
                buildFilterFunction(props, key) {
                    key = key.toLowerCase();
                    return (el) => {
                        return props.reduce((res, prop) => res || (this.extract(prop, el).includes(key)), false);
                    };
                },
                extract(prop, haystack) {
                    let val = get(haystack, prop);
                    return val ? val.toLowerCase() : '';
                },
                slugify(text) {
                    return text.toString().toLowerCase()
                        .replace(/\s+/g, '-')           // Replace spaces with -
                        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                        .replace(/^-+/, '')             // Trim - from start of text
                        .replace(/-+$/, '');            // Trim - from end of text
                }
            }
        });
    }
};

export default Helpers;



// WEBPACK FOOTER //
// ./resources/js/plugins/helper-methods.js